module.exports = ".Select{padding:0.2rem;border:solid 1px #e8e8e8}\n"